/* ============================================================
   PES In-Stock-First grid assembler (2026-09-25, Fix A)
   ------------------------------------------------------------
   Why: Shopify best-selling sort ignores inventory, and Liquid
   cannot paginate a partitioned array (no query-param access
   outside the paginate tag), so the 2026-08-14 two-pass Liquid
   render can only demote sold-out items WITHIN the current page.
   On brand collections that left page 1 = 4 in-stock panels +
   14 sold-out PES SYSTEM KITS, with 20+ in-stock panels buried
   on pages 2+.

   What this does (client-side, page 1 only):
   - fetches the next few collection pages (same URL + filters),
     parses their #product-grid cards,
   - partitions the assembled window: available first (relative
     order preserved), sold-out last,
   - re-slices into virtual pages of the original page size,
   - replaces the native pagination with virtual pages for the
     assembled window; native ?page=N links resume AFTER the
     window (item W*per+1 onward), so there are no duplicates
     and no gaps between virtual and native pages.

   Limits (documented):
   - window = first 5 pages (90 products at 18/page). Beyond the
     window, native pages keep the per-page two-pass demotion.
   - server render (no-JS / SEO) keeps the per-page two-pass.
   ============================================================ */
(function () {
  'use strict';

  var WINDOW_PAGES = 5; /* pages of the native grid assembled into the partition window */
  var inflight = false;

  function log() {
    if (window.console && console.debug) console.debug.apply(console, ['[pes-isf]'].concat([].slice.call(arguments)));
  }

  function isOOS(li) {
    return !!li.querySelector('.pes-stock-state--out');
  }

  function init() {
    var cfg = document.getElementById('pes-isf-config');
    var grid = document.getElementById('product-grid');
    if (!cfg || !grid) return;
    if (grid.getAttribute('data-pes-isf') === 'done') return;
    if (inflight) return;

    var pages = parseInt(cfg.getAttribute('data-pages'), 10) || 1;
    var per = parseInt(cfg.getAttribute('data-perpage'), 10) || 18;
    if (pages < 2) return; /* single page: Liquid two-pass already ordered it */

    var url = new URL(window.location.href);
    var curPage = parseInt(url.searchParams.get('page') || '1', 10);
    if (curPage !== 1) return; /* deep pages keep native two-pass windows */

    var items = [].slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    if (!items.length) return;
    if (!items.some(isOOS)) return; /* page 1 already fully in-stock */

    var win = Math.min(pages, WINDOW_PAGES);
    if (win < 2) return;

    inflight = true;
    var fetches = [];
    for (var p = 2; p <= win; p++) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(p));
      fetches.push(
        fetch(u.toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; })
      );
    }

    Promise.all(fetches).then(function (htmls) {
      inflight = false;
      try {
        var all = items.slice();
        var parsedPages = 0;
        htmls.forEach(function (h) {
          if (!h) return;
          var doc = new DOMParser().parseFromString(h, 'text/html');
          var g = doc.getElementById('product-grid');
          if (!g) return;
          var lis = g.querySelectorAll(':scope > li.grid__item');
          if (!lis.length) return;
          parsedPages++;
          [].forEach.call(lis, function (li) { all.push(li); });
        });
        if (parsedPages === 0) { log('no extra pages parsed; leaving native grid'); return; }

        var avail = all.filter(function (li) { return !isOOS(li); });
        var oos = all.filter(isOOS);
        if (!oos.length) return;
        var sorted = avail.concat(oos);
        var vpages = Math.ceil(sorted.length / per);

        /* Non-product tiles (e.g. installationServices) rendered inside the grid */
        var extras = [].slice.call(grid.querySelectorAll(':scope > li:not(.grid__item)'));

        var nav = document.querySelector('.collection_main_grid nav.pagination, #ProductGridContainer nav.pagination, nav.pagination');
        var navParent = nav ? nav.parentNode : null;

        function renderPage(n) {
          var slice = sorted.slice((n - 1) * per, n * per);
          grid.innerHTML = '';
          slice.forEach(function (li) { grid.appendChild(li); });
          if (n === 1 && extras.length) {
            extras.forEach(function (ex) {
              var pos = Math.min(9, grid.children.length);
              grid.insertBefore(ex, grid.children[pos] || null);
            });
          }
          grid.setAttribute('data-pes-isf', 'done');
          if (nav) {
            [].forEach.call(nav.querySelectorAll('[data-pes-vpage]'), function (b) {
              b.classList.toggle('pes-isf-active', parseInt(b.getAttribute('data-pes-vpage'), 10) === n);
            });
          }
          var anchor = document.getElementById('ProductGridContainer') || grid;
          if (n > 1 && anchor.scrollIntoView) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (nav) {
          var ul = nav.querySelector('ul') || nav;
          ul.innerHTML = '';
          var cssId = 'pes-isf-css';
          if (!document.getElementById(cssId)) {
            var st = document.createElement('style');
            st.id = cssId;
            st.textContent =
              '.pes-isf-vbtn{display:inline-flex;align-items:center;justify-content:center;min-width:40px;height:40px;padding:0 10px;margin:0 2px;border:1px solid #e5e5e5;border-radius:6px;background:#fff;color:#0f1e2d;font-size:14px;font-weight:600;cursor:pointer;text-decoration:none;}' +
              '.pes-isf-vbtn:hover{border-color:#11B67B;color:#11B67B;}' +
              '.pes-isf-vbtn.pes-isf-active{background:#11B67B;border-color:#11B67B;color:#fff;}' +
              '.pes-isf-note{width:100%;text-align:center;font-size:12px;color:#6b7c75;margin-top:6px;}';
            document.head.appendChild(st);
          }
          for (var v = 1; v <= vpages; v++) {
            (function (n) {
              var li = document.createElement('li');
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'pes-isf-vbtn' + (n === 1 ? ' pes-isf-active' : '');
              btn.setAttribute('data-pes-vpage', String(n));
              btn.textContent = String(n);
              btn.addEventListener('click', function () { renderPage(n); });
              li.appendChild(btn);
              ul.appendChild(li);
            })(v);
          }
          /* Native pages resume beyond the assembled window: no dupes, no gaps.
             Render with ellipsis like the native pagination (74+ page collections). */
          var shownNative = [];
          for (var np = win + 1; np <= pages; np++) shownNative.push(np);
          var keep = {};
          shownNative.slice(0, 2).forEach(function (n) { keep[n] = 1; });
          shownNative.slice(-2).forEach(function (n) { keep[n] = 1; });
          var lastShown = 0;
          shownNative.forEach(function (n) {
            if (!keep[n]) {
              if (lastShown && n - lastShown > 1) {
                var ell = document.createElement('li');
                var es = document.createElement('span');
                es.className = 'pes-isf-vbtn';
                es.style.border = 'none';
                es.textContent = '\u2026';
                ell.appendChild(es);
                ul.appendChild(ell);
                lastShown = 0;
              }
              return;
            }
            lastShown = n;
            var nu = new URL(window.location.href);
            nu.searchParams.set('page', String(n));
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.className = 'pes-isf-vbtn';
            a.href = nu.toString();
            a.textContent = String(n);
            li.appendChild(a);
            ul.appendChild(li);
          });
          if (pages > win) {
            var note = document.createElement('li');
            note.className = 'pes-isf-note';
            note.textContent = 'Pages 1–' + vpages + ' show available items first.';
            ul.appendChild(note);
          }
        }

        renderPage(1);
        log('assembled', sorted.length, 'cards over', parsedPages + 1, 'pages;', avail.length, 'available /', oos.length, 'sold-out;', vpages, 'virtual pages');
      } catch (e) {
        log('assembler failed, native grid left intact:', e);
      }
    });
  }

  function boot() { init(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () { setTimeout(init, 60); });

  /* facets.js swaps #ProductGridContainer via Section Rendering on filter
     changes; the fresh grid lacks our marker, so re-assemble then. */
  if (typeof MutationObserver !== 'undefined') {
    var t = null;
    var mo = new MutationObserver(function () {
      var grid = document.getElementById('product-grid');
      if (!grid) return;
      if (grid.getAttribute('data-pes-isf') === 'done') return;
      if (t) clearTimeout(t);
      t = setTimeout(init, 250);
    });
    var watch = document.getElementById('ProductGridContainer') || document.body;
    mo.observe(watch, { childList: true, subtree: true });
  }
})();
